const SidebarPlacement = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
};
export { SidebarPlacement };